var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-start":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('doc',{staticClass:"mb-4"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }